module.exports = __webpack_public_path__ + "img/Flag_of_French_Polynesia.26c025c0.svg";